import { useState, useCallback, useEffect, useRef } from 'react';

export const useKeyboardNavigation = (items, onSelect) => {
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const listRef = useRef(null);

  const handleKeyDown = useCallback(
    event => {
      if (items.length === 0) return;

      switch (event.key) {
        case 'ArrowDown':
          event.preventDefault();
          setSelectedIndex(prev => {
            const newIndex = prev < items.length - 1 ? prev + 1 : prev;
            const element = listRef.current?.children[newIndex];
            element?.scrollIntoView({ block: 'nearest' });
            return newIndex;
          });
          break;
        case 'ArrowUp':
          event.preventDefault();
          setSelectedIndex(prev => {
            const newIndex = prev > 0 ? prev - 1 : prev;
            const element = listRef.current?.children[newIndex];
            element?.scrollIntoView({ block: 'nearest' });
            return newIndex;
          });
          break;
        case 'Enter':
          event.preventDefault();
          if (selectedIndex >= 0 && selectedIndex < items.length) {
            onSelect(items[selectedIndex]);
          }
          break;
        case 'Escape':
          event.preventDefault();
          setSelectedIndex(-1);
          break;
        case 'Tab':
          event.preventDefault();
          break;
      }
    },
    [items, selectedIndex, onSelect],
  );

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown]);

  const resetSelection = useCallback(() => {
    setSelectedIndex(-1);
  }, []);

  return {
    selectedIndex,
    setSelectedIndex,
    listRef,
    resetSelection,
  };
};
